import { render } from "./CouponList.vue?vue&type=template&id=15125bdb&scoped=true&ts=true"
import script from "./CouponList.vue?vue&type=script&lang=ts"
export * from "./CouponList.vue?vue&type=script&lang=ts"

import "./CouponList.vue?vue&type=style&index=0&id=15125bdb&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15125bdb"]])